/**
 * Liquidity resource page ids (backend `LiquidityPages` enum string values).
 * Used only on stored-aggregated report URLs (`most_recently_stored_report_data_agg` /
 * `stored_report_data_agg`) as the `page_name` query parameter so the API can select
 * the response model (e.g. `params.get('page_name') == LiquidityPages.LIQUIDATION_RISK_OVERVIEW.value`).
 */
export const LiquidityPages = {
  LIQUIDITY_OVERVIEW: 'liquidity-overview-page',
  FUND_ASSET_LIQUIDATION_TIME: 'fund-asset-liquidation-time-page',
  MAXIMUM_ONE_DAY_ACHIEVABLE_BALANCE: 'maximum-one-day-achievable-balance-page',
  LASDAB: 'lasdab-page',
  LIQUIDITY_RST_FIXED_MARKET_VOLUME: 'rst-fixed-page',
  LIQUIDITY_RST_VARIABLE_MARKET_VOLUME: 'rst-variable-page',
  LIQUIDATION_RISK_OVERVIEW: 'liquidation-risk-overview-page',
  COUNTERPARTY_MARKET_LIQUIDITY_RISK: 'counterparty-market-liquidity-risk-page',
  LIQUIDITY_RISK_EVOLUTION: 'liquidity-risk-evolution-page',
  LIQUIDITY_REVERSE_STRESS_TEST_EVOLUTION: 'reverse-stress-test-evolution-page',
  AGGREGATE_LIQUIDATION_TIME: 'aggregate-liquidation-time-page',
  SUBSCRIPTION_REDEMPTIONS: 'subscription-redemptions-page',
  MARKET_LIQUIDATION_COST_SCENARIOS: 'market-liquidation-cost-scenarios-page',
  VARIABLE_MARKET_VOLUME_LIQUIDATION_COSTS:
    'variable-market-volume-liquidation-costs-page',
  LIQUIDITY_MODEL_BREAKDOWN: 'liquidity-model-breakdown-page',
} as const;

export type LiquidityPageKey = keyof typeof LiquidityPages;

export type LiquidityPageId = (typeof LiquidityPages)[LiquidityPageKey];
